import { Component, forwardRef, ViewChild, Input } from '@angular/core';
import { PlatformApiService, Results, ResultFilter } from '../../services/platform-api.service';
import { SessionService } from 'src/app/services/session.service';
import { FormGroup } from '@angular/forms';
import { Account} from '../../models/AccountModel';
import { WizardScreenComponent } from 'src/app/shared/wizard.component';
import { DataTableComponent } from 'src/app/shared/tile-data-table/tile-data-table.component';

@Component({
  selector: 'cw-ci-account-manage-users',
  templateUrl: './account-manage-users.component.html',
  styleUrls: ['./account-manage-users.component.scss'],
  providers: [{provide: WizardScreenComponent, useExisting: forwardRef(() => AccountManageUsersComponent)}]
})
export class AccountManageUsersComponent extends WizardScreenComponent {
  @ViewChild(DataTableComponent, { static: true }) userDataTable: DataTableComponent;
  userList: Results;
  @Input()
  account: Account;
  hasFailedToGetManageUsers = false;

  constructor(private _apiService: PlatformApiService) {
    super();
    this.form = new FormGroup ({});
  }

  onLoad() {
    this.userDataTable.executeLoadItems();
    super.onLoad();
  }

  loadUsers(filter = new ResultFilter()) {
    this.showSpinner();
//    this.userDataTable.showProcessing();

    console.log('loadUsers', filter);

    this._apiService.getManageUsers(this.account.id, filter).subscribe(
      results => {
        this.userList = results;
        this.hasFailedToGetManageUsers = false;
        this.hideSpinner();
      },
      err => {
        this.hasFailedToGetManageUsers = true;
        this.userList = new Results(null, 0);
        this.hideSpinner();
      }
    );
  }

  isSelectable(user) {
    return false;
  }

  allowAccess(row) {
    this._apiService.addManageUser(this.account.id, row).subscribe(
      results=> {
        this.userDataTable.executeLoadItems();
      }
    );
  }

  revokeAccess(row) {
    this._apiService.revokeManageUser(this.account.id, row).subscribe(
      results=> {
        this.userDataTable.executeLoadItems();
      }
    );
  }

  isSaveButtonDisabled() {
    return false;
  }
}